import { useState, useEffect } from 'react';

export function Outcomes({ t }) {
  const RED = 'var(--brandRed)';
  const [coachingOpen, setCoachingOpen] = useState(false);
  // Billing state retained from the original component — used by the
  // (currently disabled) PriceCTA blocks. Kept so re-enabling them is a
  // one-line change.
  const [billing, setBilling] = useState('annual');

  const fastTokens = {
    text: '#fff',
    sub: 'rgba(255,255,255,.92)',
    muted: 'rgba(255,255,255,.72)',
    rule: 'rgba(255,255,255,.18)',
    cardBg: 'rgba(255,255,255,.10)',
    cardBorder: 'rgba(255,255,255,.20)',
  };
  const easyTokens = {
    text: 'var(--fg-1)',
    sub: 'var(--fg-1)',
    muted: 'var(--grey)',
    rule: 'var(--border)',
    cardBg: '#fff',
    cardBorder: 'var(--border)',
  };

  return (
    <section className="ssi-out" style={outcomesStyles.wrap}>
      <div style={outcomesStyles.head}>
        <div style={outcomesStyles.kicker}>{t.outcomesKicker}</div>
        <h2 style={outcomesStyles.h2}>{t.outcomesTitle}</h2>
        <p style={outcomesStyles.lede}>{t.outcomesLede}</p>
      </div>

      <div style={outcomesStyles.mountain}>
        <img
          src="/assets/fast-or-easy-mountain.svg?v=dotted"
          alt="A mountain with two routes to the summit: a short straight climb labelled 'fast', and a winding path of switchbacks labelled 'easy'."
          style={outcomesStyles.mountainImg}
        />
      </div>

      <div className="ssi-out__grid" style={outcomesStyles.grid}>
        {/* FAST column */}
        <article style={{ ...outcomesStyles.col, background: RED, color: fastTokens.text }}>
          <div style={{ borderBottom:`1px solid ${fastTokens.rule}`, paddingBottom:20 }}>
            <div style={{ ...outcomesStyles.colLabel, color:fastTokens.muted }}>Option A</div>
            <h3 style={{ ...outcomesStyles.colTitle, color:fastTokens.text }}>{t.outcomesFastTitle}</h3>
            <div style={{ ...outcomesStyles.colTrade, color:fastTokens.sub }}>{t.outcomesFastTrade}</div>
            <p style={{ ...outcomesStyles.colBody, color:fastTokens.sub, marginTop:16 }}>{t.outcomesFastBody}</p>
          </div>

          <div style={{ ...outcomesStyles.subCard, background:fastTokens.cardBg, border:`1px solid ${fastTokens.cardBorder}` }}>
            <div style={{ ...outcomesStyles.subLabel, color:fastTokens.muted }}>{t.outcomesFastA_Label}</div>
            <div style={{ ...outcomesStyles.subTitle, color:fastTokens.text }}>{t.outcomesFastA_Title}</div>
            <p style={{ ...outcomesStyles.subBody, color:fastTokens.sub }}>{t.outcomesFastA_Body}</p>
            <div style={{ ...outcomesStyles.subStatRow, borderTop:`1px solid ${fastTokens.rule}` }}>
              <span style={{ ...outcomesStyles.subStat, color:fastTokens.text }}>{t.outcomesFastA_Stat}</span>
              <span style={{ ...outcomesStyles.subStatLabel, color:fastTokens.sub }}>{t.outcomesFastA_StatLabel}</span>
            </div>
          </div>

          <div style={{ ...outcomesStyles.subCard, background:fastTokens.cardBg, border:`1px solid ${fastTokens.cardBorder}` }}>
            <div style={{ ...outcomesStyles.subLabel, color:fastTokens.muted }}>{t.outcomesFastB_Label}</div>
            <div style={{ ...outcomesStyles.subTitle, color:fastTokens.text }}>{t.outcomesFastB_Title}</div>
            <p style={{ ...outcomesStyles.subBody, color:fastTokens.sub }}>{t.outcomesFastB_Body}</p>
            <div style={{ ...outcomesStyles.subStatRow, borderTop:`1px solid ${fastTokens.rule}` }}>
              <span style={{ ...outcomesStyles.subStat, color:fastTokens.text }}>{t.outcomesFastB_Stat}</span>
              <span style={{ ...outcomesStyles.subStatLabel, color:fastTokens.sub }}>{t.outcomesFastB_StatLabel}</span>
            </div>
            <button type="button" onClick={()=>setCoachingOpen(true)} style={{
              ...outcomesStyles.ctaLight,
              borderColor:fastTokens.cardBorder,
              color:fastTokens.text,
              cursor:'pointer', font:'inherit', textAlign:'center',
            }}>
              Talk to Aran <span aria-hidden>→</span>
            </button>
          </div>
        </article>

        <div className="ssi-out__divider" style={outcomesStyles.divider} aria-hidden>
          <span style={outcomesStyles.dividerLine}/>
          <span style={outcomesStyles.dividerWord}>or</span>
          <span style={outcomesStyles.dividerLine}/>
        </div>

        {/* EASY column */}
        <article style={{ ...outcomesStyles.col, background:'var(--offWhite)', color:easyTokens.text, border:'1px solid var(--border)' }}>
          <div style={{ borderBottom:`1px solid ${easyTokens.rule}`, paddingBottom:20 }}>
            <div style={{ ...outcomesStyles.colLabel, color:easyTokens.muted }}>Option B</div>
            <h3 style={{ ...outcomesStyles.colTitle, color:easyTokens.text }}>{t.outcomesEasyTitle}</h3>
            <div style={{ ...outcomesStyles.colTrade, color:easyTokens.sub }}>{t.outcomesEasyTrade}</div>
            <p style={{ ...outcomesStyles.colBody, color:easyTokens.sub, marginTop:16 }}>{t.outcomesEasyBody}</p>
          </div>

          <div style={outcomesStyles.timeline}>
            {[
              { stat: t.outcomesEasyStat1, label: t.outcomesEasyStatLabel1 },
              { stat: t.outcomesEasyStat2, label: t.outcomesEasyStatLabel2 },
              { stat: t.outcomesEasyStat,  label: t.outcomesEasyStatLabel },
            ].map((m, i) => (
              <div key={i} style={{
                ...outcomesStyles.proofCard,
                background: easyTokens.cardBg,
                border: `1px solid ${easyTokens.cardBorder}`,
              }}>
                <div style={{ ...outcomesStyles.proofStat, color:easyTokens.text }}>{m.stat}</div>
                <div style={{ ...outcomesStyles.proofLabel, color:easyTokens.muted }}>{m.label}</div>
              </div>
            ))}
          </div>
          <div style={{ ...outcomesStyles.colMeta, color:easyTokens.muted }}>{t.outcomesEasyMeta}</div>
        </article>
      </div>

      <div style={outcomesStyles.footer}>
        <div style={outcomesStyles.footerBar}/>
        <p style={outcomesStyles.footerText}>{t.outcomesFooter}</p>
      </div>

      {coachingOpen && <CoachingModal onClose={()=>setCoachingOpen(false)} t={t}/>}
    </section>
  );
}

const outcomesStyles = {
  wrap: { background:'#fff', padding:'104px 32px 96px', maxWidth:1440, margin:'0 auto' },
  head: { textAlign:'center', maxWidth:720, margin:'0 auto 40px' },
  kicker: { fontSize:12, letterSpacing:'.14em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:600, marginBottom:12 },
  h2: { fontFamily:'var(--font-display)', fontSize:52, lineHeight:1.05, margin:'0 0 16px', letterSpacing:'-.015em' },
  lede: { fontSize:18, color:'var(--grey)', margin:0, lineHeight:1.55, textWrap:'pretty' },

  mountain: { maxWidth:1040, margin:'0 auto 56px', padding:'0 16px' },
  mountainImg: { display:'block', width:'100%', height:'auto' },

  grid: { display:'grid', gridTemplateColumns:'1fr auto 1fr', gap:0, alignItems:'stretch', maxWidth:1180, margin:'0 auto' },
  col: { padding:'40px 40px 32px', borderRadius:20, display:'flex', flexDirection:'column', gap:18, position:'relative' },
  colLabel: { fontSize:11, letterSpacing:'.16em', textTransform:'uppercase', fontWeight:600, marginBottom:10 },
  colTitle: { fontFamily:'var(--font-display)', fontSize:44, lineHeight:1, letterSpacing:'-.02em', margin:'0 0 10px' },
  colTrade: { fontSize:15, fontWeight:500, letterSpacing:'-.005em' },
  colBody: { fontSize:15, lineHeight:1.6, margin:0, textWrap:'pretty' },

  subCard: { borderRadius:14, padding:'20px 22px', display:'flex', flexDirection:'column', gap:10 },
  subLabel: { fontSize:10, letterSpacing:'.18em', textTransform:'uppercase', fontWeight:600 },
  subTitle: { fontFamily:'var(--font-display)', fontSize:22, lineHeight:1.15, letterSpacing:'-.01em' },
  subBody: { fontSize:14, lineHeight:1.55, margin:0, textWrap:'pretty' },
  subStatRow: { display:'flex', flexDirection:'column', gap:10, paddingTop:16, marginTop:4 },
  subStat: { fontFamily:'var(--font-display)', fontSize:22, lineHeight:1.15, letterSpacing:'-.01em' },
  subStatLabel: { fontSize:14, lineHeight:1.55 },

  proofCard: { borderRadius:14, padding:'18px 20px' },
  proofStat: { fontFamily:'var(--font-display)', fontSize:28, lineHeight:1.1, letterSpacing:'-.015em', marginBottom:4 },
  proofLabel: { fontSize:13, lineHeight:1.4 },

  timeline: { display:'flex', flexDirection:'column', gap:12, marginTop:24, marginBottom:4 },

  ctaLight: {
    display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center', gap:8,
    padding:'12px 16px', borderRadius:10,
    background:'transparent', border:'1px solid',
    fontSize:14, fontWeight:600, textDecoration:'none',
    marginTop:4, transition:'background 160ms ease',
  },
  colMeta: { fontSize:12, letterSpacing:'.14em', textTransform:'uppercase', fontWeight:600 },

  divider: { display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'0 32px', gap:16 },
  dividerLine: { width:1, flex:1, background:'var(--border)', display:'block', minHeight:40 },
  dividerWord: { fontFamily:'var(--font-display)', fontSize:20, color:'var(--grey)', fontStyle:'italic', letterSpacing:'-.01em' },

  footer: { maxWidth:820, margin:'56px auto 0', textAlign:'center', display:'flex', flexDirection:'column', alignItems:'center', gap:16 },
  footerBar: { width:48, height:2, background:'var(--brandRed)' },
  footerText: { fontFamily:'var(--font-display)', fontSize:22, lineHeight:1.4, margin:0, color:'var(--fg-1)', letterSpacing:'-.005em', textWrap:'balance' },
};

function CoachingModal({ onClose, t }) {
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (e.target.elements.website && e.target.elements.website.value) return;
    setSubmitting(true);
    setError(null);
    const data = Object.fromEntries(new FormData(e.target).entries());
    try {
      const res = await fetch(`${import.meta.env.VITE_API_BASE}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ form: 'outcomes', ...data }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSent(true);
    } catch {
      setError(t.coachError ?? 'Something went wrong — please try again or email us directly.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={coachStyles.backdrop} onClick={onClose} role="dialog" aria-modal="true" aria-label="Talk to Aran about coaching">
      <div style={coachStyles.card} onClick={e=>e.stopPropagation()}>
        <button type="button" onClick={onClose} style={coachStyles.close} aria-label="Close">×</button>

        {!sent ? (
          <>
            <div style={coachStyles.kicker}>{t.coachKicker}</div>
            <h3 style={coachStyles.h3}>{t.coachTitle}</h3>
            <p style={coachStyles.lede}>{t.coachLede}</p>
            {t.coachLede2 && <p style={coachStyles.lede}>{t.coachLede2}</p>}

            <form onSubmit={handleSubmit} style={coachStyles.form}>
              <div aria-hidden="true" style={{position:'absolute', left:'-10000px', top:'auto', width:1, height:1, overflow:'hidden'}}>
                <label>Website (leave this empty)<input type="text" name="website" tabIndex={-1} autoComplete="off"/></label>
              </div>
              <label style={coachStyles.field}>
                <span style={coachStyles.label}>{t.coachNameLabel}</span>
                <input type="text" name="name" required style={coachStyles.input} placeholder={t.coachNamePlaceholder}/>
              </label>
              <label style={coachStyles.field}>
                <span style={coachStyles.label}>{t.coachEmailLabel}</span>
                <input type="email" name="email" required style={coachStyles.input} placeholder={t.coachEmailPlaceholder}/>
              </label>
              <label style={coachStyles.field}>
                <span style={coachStyles.label}>{t.coachPrepLabel}</span>
                <textarea name="message" required style={{...coachStyles.input, minHeight:110, resize:'vertical', font:'inherit'}} placeholder={t.coachPrepPlaceholder}/>
              </label>
              <label style={coachStyles.field}>
                <span style={coachStyles.label}>{t.coachLangLabel}</span>
                <input type="text" name="topic" required style={coachStyles.input} placeholder={t.coachLangPlaceholder}/>
              </label>
              {error && <p style={{...coachStyles.fine, color:'var(--brandRed)'}}>{error}</p>}
              <div style={coachStyles.actions}>
                <button type="button" onClick={onClose} style={coachStyles.btnGhost}>{t.coachCancel}</button>
                <button type="submit" disabled={submitting} style={coachStyles.btnSolid}>{submitting ? '…' : t.coachSend}</button>
              </div>
              <p style={coachStyles.fine}>{t.coachFine}</p>
            </form>
          </>
        ) : (
          <div style={{textAlign:'center', padding:'12px 0'}}>
            <div style={coachStyles.tick} aria-hidden>✓</div>
            <h3 style={coachStyles.h3}>{t.coachSentTitle}</h3>
            <p style={coachStyles.lede}>{t.coachSentLede}</p>
            <div style={{display:'flex', justifyContent:'center', gap:10, marginTop:24}}>
              <button type="button" onClick={onClose} style={coachStyles.btnGhost}>{t.coachSentClose}</button>
              <a href="#sample" onClick={onClose} style={{...coachStyles.btnSolid, textDecoration:'none'}}>{t.coachSentCta}</a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const coachStyles = {
  backdrop: { position:'fixed', inset:0, background:'rgba(73,3,0,.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:60, padding:20, backdropFilter:'blur(2px)' },
  card: { background:'#fff', borderRadius:20, width:'100%', maxWidth:540, padding:'36px 40px 32px', boxShadow:'var(--shadow-lg, 0 24px 60px -20px rgba(73,3,0,.4))', position:'relative', maxHeight:'90vh', overflow:'auto' },
  close: { position:'absolute', top:14, right:14, width:36, height:36, borderRadius:'50%', border:0, background:'rgba(30,20,18,.06)', fontSize:22, lineHeight:1, cursor:'pointer', color:'var(--grey)' },
  kicker: { fontSize:12, letterSpacing:'.14em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:600, marginBottom:10 },
  h3: { fontFamily:'var(--font-display)', fontSize:30, lineHeight:1.1, margin:'0 0 10px', letterSpacing:'-.01em', color:'var(--fg-1)' },
  lede: { fontSize:15, lineHeight:1.6, color:'var(--grey)', margin:'0 0 24px', textWrap:'pretty' },
  form: { display:'flex', flexDirection:'column', gap:14 },
  field: { display:'flex', flexDirection:'column', gap:6 },
  label: { fontSize:12, letterSpacing:'.06em', textTransform:'uppercase', color:'var(--grey)', fontWeight:600 },
  input: { padding:'12px 14px', borderRadius:10, border:'1px solid var(--border)', fontSize:15, fontFamily:'inherit', color:'var(--fg-1)', background:'#fff', outline:'none', transition:'border-color 160ms ease' },
  actions: { display:'flex', gap:10, justifyContent:'flex-end', marginTop:6 },
  btnGhost: { padding:'12px 18px', borderRadius:10, border:'1px solid var(--border)', background:'#fff', fontSize:14, fontWeight:600, cursor:'pointer', font:'inherit', color:'var(--fg-1)' },
  btnSolid: { padding:'12px 20px', borderRadius:10, background:'var(--brandRed)', color:'#fff', border:0, fontSize:14, fontWeight:600, cursor:'pointer', font:'inherit', boxShadow:'0 6px 16px -6px rgba(178,25,45,.55)' },
  fine: { fontSize:12, color:'var(--grey)', margin:'6px 0 0', lineHeight:1.5 },
  tick: { width:56, height:56, borderRadius:'50%', background:'var(--brandRed)', color:'#fff', fontSize:28, fontWeight:600, margin:'0 auto 16px', display:'flex', alignItems:'center', justifyContent:'center' },
};
